import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.less";
import cx from "classnames";

/// Thumbnail has 2 types of views:
/// The carousel room type ( has it is in the room results view )
/// The hotel/room type inside GroupResult ( has it is in the region results view and any mobile view )
/// *** CURRENTLY UNAVAILABLE OPTION *** extendedType prop: 'true' - for hotel type ( hotel type  is more exetended ) , otherwise - room type.

const imageSrcWithCrop = src => `${src}?w=450&h=300&mode=crop`;

class ThumbNailImage extends React.Component {
  defaultLoadAttempt = 0;

  getProductImage = product => {
    const { getDefaultImage } = this.props;
    // const hasImages =
    //   product.images &&
    //   //Array.isArray(product.images) &&
    //   product.images.length > 0;
    (product.images && product.images[0]) || getDefaultImage();
  };

  render() {
    const {
      product,
      titles,
      renderImageMarkup,
      onImageLoad,
      isIos,
      onError
    } = this.props;
    const productImage = product.images[0];
    return (
      <div className={cx(styles.imageWrapper, { [styles.iosIsShit]: isIos })}>
        {renderImageMarkup && renderImageMarkup(product)}
        <img
          src={imageSrcWithCrop(productImage)}
          alt={`${product.name} ${titles.room}`}
          onError={onError}
          onLoad={onImageLoad}
        />
      </div>
    );
  }
}

ThumbNailImage.propTypes = {
  titles: PropTypes.object,
  product: PropTypes.object,
  onImageLoad: PropTypes.func,
  renderImageMarkup: PropTypes.func,
  isIos: PropTypes.bool,
  onError: PropTypes.func,
  getDefaultImage: PropTypes.func
};

export default ThumbNailImage;



// WEBPACK FOOTER //
// ./src/components/ThumbNailImage/ThumbNailImage.js